import type React from "react";
import { LinkProps, useOutletContext } from "react-router-dom";

export type BreadcrumbItem = Pick<LinkProps, "children" | "to">;

export type ClientOutletContext = {
  breadcrumbItems: BreadcrumbItem[];
  setBreadcrumbItems: React.Dispatch<React.SetStateAction<BreadcrumbItem[]>>;
  defaultItems: BreadcrumbItem[];
  pageTitle: string;
  setPageTitle: React.Dispatch<React.SetStateAction<string>>;
  showClientTabs: boolean;
  setShowClientTabs: React.Dispatch<React.SetStateAction<boolean>>;
};

export function useClientUIContext(): ClientOutletContext {
  return useOutletContext<ClientOutletContext>();
}
